import React from 'react'
import PropTypes from 'prop-types'
import {Form, Input, Textarea, Checkbox} from 'formsy-react-components'

import {Alert, BoxContent, AdminForm} from '../components'
import {Http, i18n} from 'common'


export default class BlacklistEdit extends React.Component {
    static contextTypes = {
        notificator: PropTypes.object.isRequired
    }

    state = {
        allowsSubmit: false,
        errorMessage: null
    }

    onSubmit = (data) => {
        Http.POST('api/blacklist', data, () => {
            const {notificator} = this.context
            notificator.message(i18n('form.success'))

            this.props.onChange &&
                this.props.onChange()
        })
    }

    render() {
        const {errorMessage} = this.state

        return (
            <div className="pl2 pr2 pt3">
                <div>
                    <Alert text={i18n('blacklist-form.hint')} type="error" />
                </div>

                <Form
                    onValidSubmit={this.onSubmit}
                    onValid={() => this.setState({allowsSubmit: true, errorMessage: null})}
                    onInvalid={(e) => this.setState({allowsSubmit: false, errorMessage: e})}
                >

                    <Input
                        name='uri'
                        placeholder={i18n('blacklist-form.placeholders.url')}
                        validations='isUrl'
                        validationError={i18n('error.http-format')}
                        layout='elementOnly'
                        required
                    />

                    <button className="btn btn--primary ml1" disabled={!this.state.allowsSubmit}>
                        <i className="icon fa fa-plus mr05" />
                        <span>{i18n('blacklist-form.new')}</span>
                    </button>

                    {errorMessage &&
                        <span className="f-error-message">{errorMessage}</span>}
                </Form>

                <hr className="mt3" />
            </div>
        );
    }
}
